import(/* webpackMode: "eager", webpackExports: ["PlatformComputerVision"] */ "/vercel/path0/components/sections/platform/PlatformComputerVision.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformCTA"] */ "/vercel/path0/components/sections/platform/PlatformCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformDeploymentArchitecture"] */ "/vercel/path0/components/sections/platform/PlatformDeploymentArchitecture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformHero"] */ "/vercel/path0/components/sections/platform/PlatformHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformIntelligenceStack"] */ "/vercel/path0/components/sections/platform/PlatformIntelligenceStack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformReasoningLayer"] */ "/vercel/path0/components/sections/platform/PlatformReasoningLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformSignalFlow"] */ "/vercel/path0/components/sections/platform/PlatformSignalFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformValidation"] */ "/vercel/path0/components/sections/platform/PlatformValidation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ground"] */ "/vercel/path0/components/visual/scene/Ground.tsx");
